var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import "@frameworks/shared-library/stylesheets/components/GenericCheckbox/GenericCheckbox.scss";
var Checkbox = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: "primary-offerings-table-wrapper" },
        React.createElement("label", { className: "".concat((_a = props.parentClassName) !== null && _a !== void 0 ? _a : "", " primary-generic-checkbox-container common-checkbox-custom d-flex align-items-center gap-2") },
            React.createElement("input", __assign({ type: "checkbox" }, props.checkboxProps, { className: "generic-checkbox align-self-start ".concat((_b = props === null || props === void 0 ? void 0 : props.checkboxType) !== null && _b !== void 0 ? _b : "", " ").concat((_d = (_c = props === null || props === void 0 ? void 0 : props.checkboxProps) === null || _c === void 0 ? void 0 : _c.className) !== null && _d !== void 0 ? _d : ""), style: { width: "16px", height: "16px" } })),
            props.list && (React.createElement("span", { className: "disp_val" },
                props.list.display,
                props.list.desc && (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "d-flex DMsanL_12_300 txt_primaryGrey description-content" }, props.list.desc))))))));
};
export default Checkbox;
